import React, { useReducer } from 'react';
import { StyleSettingsImageUploaderActionTypes } from './StyleSettingsImageUploaderActions';
import {
	StyleSettingsImageUploaderContext,
	styleSettingsImageUploaderInitialState,
	TTypeOfErrorModalWindow,
	TTypeOfModalWindow,
} from './styleSettingsImageUploaderContext';
import { styleSettingsImageUploaderReducer } from './styleSettingsImageUploaderReducer';
import { postMediaFileForStyleSettings } from 'backend/additionalInformation';

const StyleSettingsImageUploaderState: React.FC = ({ children }) => {
	const [state, dispatch] = useReducer(styleSettingsImageUploaderReducer, styleSettingsImageUploaderInitialState);

	const setLoading = (value: boolean) => {
		dispatch({
			type: StyleSettingsImageUploaderActionTypes.SET_LOADING,
			payload: {
				isLoading: value,
			},
		});
	};

	const setUploaderSrc = (value: string | null) => {
		dispatch({
			type: StyleSettingsImageUploaderActionTypes.SET_UPLOADER_SRC,
			payload: {
				src: value,
			},
		});
	};

	const setCropperSrc = (value: string | null) => {
		dispatch({
			type: StyleSettingsImageUploaderActionTypes.SET_CROPPER_SRC,
			payload: {
				src: value,
			},
		});
	};

	const changeTypeOfModalWindow = (value: TTypeOfModalWindow) => {
		dispatch({
			type: StyleSettingsImageUploaderActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW,
			payload: {
				typeOfModalWindow: value,
			},
		});
	};

	const changeTypeOfErrorModalWindow = (value: TTypeOfErrorModalWindow) => {
		dispatch({
			type: StyleSettingsImageUploaderActionTypes.CHANGE_TYPE_OF_ERROR_MODAL_WINDOW,
			payload: {
				typeOfErrorModalWindow: value,
			},
		});
	};

	const setLoadingImageError = (value: boolean) => {
		dispatch({
			type: StyleSettingsImageUploaderActionTypes.SET_LOADING_IMAGE_ERROR,
			payload: {
				loadingImageError: value,
			},
		});
	};

	const setNewImageUploaded = (value: boolean) => {
		dispatch({
			type: StyleSettingsImageUploaderActionTypes.SET_NEW_IMAGE_UPLOADED,
			payload: {
				isNewImageUploaded: value,
			},
		});
	};

	const uploadImage = async (image: Blob) => {
		// setLoading(true);
		const formData = new FormData();
		const createImageName = () => {
			const indexOfBlobTypeSeparator = image.type.indexOf('/');
			const fileExtension = image.type.slice(indexOfBlobTypeSeparator + 1);
			return `image.${fileExtension}`;
		};
		formData.append('file', image, createImageName());
		try {
			const response = await postMediaFileForStyleSettings(formData);
			return response.data.fileId;
		} catch (err) {
			// changeTypeOfErrorModalWindow('fileUploadError');
			return undefined;
		} finally {
			// setLoading(false);
		}
	};

	return (
		<StyleSettingsImageUploaderContext.Provider
			value={{
				setLoading,
				setUploaderSrc,
				setCropperSrc,
				changeTypeOfModalWindow,
				changeTypeOfErrorModalWindow,
				setLoadingImageError,
				setNewImageUploaded,
				uploadImage,
				isLoading: state.isLoading,
				uploaderSrc: state.uploaderSrc,
				cropperSrc: state.cropperSrc,
				typeOfModalWindow: state.typeOfModalWindow,
				typeOfErrorModalWindow: state.typeOfErrorModalWindow,
				loadingImageError: state.loadingImageError,
				isNewImageUploaded: state.isNewImageUploaded,
			}}>
			{children}
		</StyleSettingsImageUploaderContext.Provider>
	);
};

export default StyleSettingsImageUploaderState;
